import type { MatchTimelinePoint } from "@/types";

const POINT_LABELS = ["0", "15", "30", "40"];

export interface ScoredPoint extends MatchTimelinePoint {
  gameNumber: number;
  // "15-0", "40-30"... o el marcador numérico simple de un tie-break ("3-2"). Siempre refleja
  // el marcador que había cuando se jugó este punto, salvo que gameWon sea true (entonces este
  // punto es el que cerró el juego: ver gameWinner).
  scoreLabel: string;
  gameWon: boolean;
  gameWinner: "A" | "B" | null;
  // Juego decidido en el empate a 40 (el sistema no usa ventaja: el siguiente punto gana el
  // juego directamente, igual que ya hace el marcador en vivo — ver ScoreboardOverlay).
  goldenPoint: boolean;
  // Juego de desempate (6 juegos iguales en el set): el marcador pasa a ser numérico simple
  // (1-0, 2-1...) en vez de 15/30/40.
  isTiebreak: boolean;
}

// Reconstruye el marcador punto a punto a partir del registro de quién ganó cada punto: el
// backend solo guarda eso (equipo + set), no el marcador en vivo punto a punto, así que hay que
// "rejugar" el set aplicando las reglas de pádel (15/30/40, punto de oro en el 40-40, y un
// tie-break sencillo a 7 con 2 de ventaja en cuanto ambos equipos llegan a 6 juegos).
export function scorePoints(points: MatchTimelinePoint[]): ScoredPoint[] {
  const ordered = [...points].sort((x, y) => x.offsetSeconds - y.offsetSeconds);
  const result: ScoredPoint[] = [];

  let currentSet = ordered[0]?.setJuego;
  let gamesA = 0;
  let gamesB = 0;
  let a = 0;
  let b = 0;
  let gameNumber = 1;

  for (const point of ordered) {
    if (point.setJuego !== currentSet) {
      currentSet = point.setJuego;
      gamesA = 0;
      gamesB = 0;
      a = 0;
      b = 0;
      gameNumber = 1;
    }

    const isTiebreak = gamesA === 6 && gamesB === 6;
    let scoreLabel: string;
    let gameWon = false;
    let gameWinner: "A" | "B" | null = null;
    let goldenPoint = false;

    if (isTiebreak) {
      if (point.equipo === "A") a++;
      else b++;
      scoreLabel = `${a}-${b}`;
      if ((a >= 7 || b >= 7) && Math.abs(a - b) >= 2) {
        gameWon = true;
        gameWinner = a > b ? "A" : "B";
      }
    } else if (a === 3 && b === 3) {
      goldenPoint = true;
      gameWon = true;
      gameWinner = point.equipo;
      scoreLabel = "40-40";
    } else {
      if (point.equipo === "A") a++;
      else b++;
      if (a >= 4 || b >= 4) {
        gameWon = true;
        gameWinner = a > b ? "A" : "B";
      }
      scoreLabel = `${POINT_LABELS[Math.min(a, 3)]}-${POINT_LABELS[Math.min(b, 3)]}`;
    }

    result.push({ ...point, gameNumber, scoreLabel, gameWon, gameWinner, goldenPoint, isTiebreak });

    if (gameWon && gameWinner) {
      if (gameWinner === "A") gamesA++;
      else gamesB++;
      gameNumber++;
      a = 0;
      b = 0;
    }
  }

  return result;
}
